import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/aenderungsanfrage_FULL_Paths.json';
const P = Schema.attributes;

const BegruendungAenderungsAnfrage: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Begründung" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};

export default BegruendungAenderungsAnfrage;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Aenderungsanfrage_Begruendung_Des_Antragstellers_Aenderungsart,
					type: 'multiSelect',
				},
				{
					...P.Aenderungsanfrage_Begruendung_Des_Antragstellers_Begruendung,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBegruendungAenderungsAnfrage = () => {
	return concat(formStruc());
};
